export default "__VITE_ASSET__BxB5wEe8__"